import React from 'react';
import { Input, } from 'antd';
import Icon from 'components/Icon';
import $$ from 'cmn-utils';

export default class Search extends React.PureComponent {
  static defaultProps = {
    placeholder: ''
  };

  state = {
    value: '',
  }

  constructor(props) {
    super(props);
    this.onChange = $$.debounce(props.onChange, 500);
  }

  handleChange = value => {
    this.setState({
      value
    })
  };

  handleSearch = value => {
    const onChange = this.props.onChange;
    if (onChange) {
      this.onChange(this.state.value);
    }
  }

  handleClear = e => {
    e.preventDefault();

    const handleClear = this.props.handleClear;
    if (handleClear) {
      handleClear(e);
    }
    this.setState({
      value: ''
    })
  };

  render() {
    const { placeholder, prefixCls } = this.props;
    const icon =
      this.state.value && this.state.value.length > 0 ? (
        <a className={`search-action`} onClick={this.handleClear}>
          <Icon className="close-o" />
        </a>
      ) : null;

    const searchBtn = <span className={`search-do`} onClick={this.handleSearch}>
      <Icon className="search-o" />
    </span>

    return (
      <div className={`search-content`}>
        <Input
          placeholder={placeholder}
          className={prefixCls}
          value={this.state.value}
          ref="input"
          onChange={e => this.handleChange(e.target.value)}
          onKeyDown={e => {
            if(e.keyCode === 13){
              this.handleSearch()
            }
          }}
        />
        {searchBtn}
        {icon}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Search/Search.js